// Réglages du fond animé. Modifier puis recharger la page (ou relancer le build).
export default {
  dots: {
    count: 3000, // Nombre total de points, répartis sur les filaments.
    strands: 30, // Nombre de filaments (entier positif).
    size: 1, // Multiplicateur de taille des points.
    opacity: 1 // Multiplicateur de luminosité, de 0 à 1.
  },
  network: {
    anchors: 90, // Nombre de points participant aux connexions.
    lineOpacity: .55,
    pulseSpeed: .65,
    wordOpacity: .9,
    words: [ 'WEB', 'FRONT', 'BACK', '</>', '</>', 'API', 'NODE', 'UI', 'DATA', 'UX', 'CODE', 'JSON', 'HTTP', 'DOM', 'GIT', 'SQL', 'CLOUD', 'REACT', 'VUE', 'OPEN SOURCE', 'BUILD', 'DESIGN', 'DEV' ]
  },
  colors: {
    // Couleurs RGB des particules : on peut ajouter ou retirer des couleurs.
    palette: [ '255, 255, 255', '128, 128, 128', '100, 100, 100', '200, 200, 200' ],
    stars: '90, 170, 255',
    cycleSpeed: .35,
    // Décalage de teinte en degrés pour chaque page.
    sectionHue: { hero: 0, works: 0, references: 100, contributions: 210 },
    transitionSeconds: 1.6
  },
  animation: {
    speed: 1, // Vitesse globale ; 0 fige la rotation et les transformations.
    rotationSpeed: .09, // Radians par seconde.
    sphereHold: 7, // Durées en secondes.
    morphDuration: 5,
    torusHold: 8,
    sphereRest: 1
  },
  shape: {
    width: .48, // Rayon maximal en proportion de la largeur de l'écran.
    height: .47, // Rayon maximal en proportion de la hauteur de l'écran.
    centerY: .48,
    tilt: .85, // Inclinaison initiale en radians.
    ripple: .095,
    fold: .045,
    twist: .18
  },
  mouse: {
    horizontal: 1.8, // Amplitude en radians sur toute la largeur / hauteur.
    vertical: 1.4,
    easing: .035 // Entre 0 et 1 : plus élevé = réaction plus immédiate.
  },
  stars: { count: 110 },
  glow: {
    enabled: true,
    intensity: 1,
    bokeh: true // Halos flous sur certains points au premier plan.
  },
  performance: {
    fps: 30,
    pixelRatio: 1.5 // Limite de résolution sur les écrans Retina.
  }
}
